import { IAPIRoutes } from "../../../../config";

export type IVitalSyncRepository = ReturnType<
  typeof VitalSyncRepositoryFactory
>;

export const VitalSyncRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST, GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const ExtractVitalsAPI: IExtractVitalsAPI = async (payload) => {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("patient_id", payload.patient_id);

    return POST(
      APIRoutes.apiExtractVitals.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        // Don't set Content-Type for FormData, let the browser set it with boundary
      }
    );
  };

  const SubmitVitalsToPCCAPI: ISubmitVitalsToPCCAPI = async (payload) =>
    POST(
      APIRoutes.apiSubmitVitalsToPCC.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        "Content-Type": "application/json",
      }
    );

  const GetPCCSubmissionStatisticsAPI: IGetPCCSubmissionStatisticsAPI = async (
    payload
  ) => {
    const params: Record<string, string> = {};
    if (payload.start_date) {
      params.start_date = payload.start_date;
    }
    if (payload.end_date) {
      params.end_date = payload.end_date;
    }

    return GET(
      APIRoutes.apiGetPCCSubmissionStatistics.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      params,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const GetPCCQueueListAPI: IGetPCCQueueListAPI = async (payload) => {
    const params: Record<string, string> = {};
    if (payload.patient_id !== undefined) {
      params.patient_id = payload.patient_id.toString();
    }
    if (payload.status) {
      params.status = payload.status;
    }
    if (payload.limit !== undefined) {
      params.limit = payload.limit.toString();
    }
    if (payload.offset !== undefined) {
      params.offset = payload.offset.toString();
    }

    return GET(
      APIRoutes.apiGetPCCQueueList.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      params,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  return {
    ExtractVitalsAPI,
    SubmitVitalsToPCCAPI,
    GetPCCSubmissionStatisticsAPI,
    GetPCCQueueListAPI,
  };
};
